import { EditOutlined, MessageOutlined } from '@ant-design/icons';
import {
  Card,
  Col,
  List,
  Popover,
  Spin,
  Tooltip,
  Typography,
  message
} from 'antd';
import React, { useEffect, useState } from 'react';
import Image360 from '../../../components/Image360';
import { CONFIG } from '../../../constants';
import {
  InspeccionProvider,
  useInspeccionContext
} from '../../../context/inspeccion-context';
import { b64toBlob } from '../../../functions/images';
import Comentarios from './Comentarios';
import Editor from './Editor';

const { Meta } = Card;
const { Paragraph } = Typography;

export default function TarjetaEdit(props) {
  const {
    uploadMarkedFile,
    archivoAddComentario,
    archivoAddParte
  } = useInspeccionContext();
  const [imagen, setImagen] = useState(null);
  const [imagenReal, setImagenReal] = useState(null);
  const [imagenMarcada, setImagenMarcada] = useState(null);
  const [imagenEditada, setImagenEditada] = useState(null);
  const [fileName, setFileName] = useState(null);
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [comentario, setComentario] = useState([]);
  const [comentarioTooltip, setComentarioTooltip] = useState(false);
  const [parte, setParte] = useState();
  const {
    card,
    imagenes,
    solicitud,
    inspeccion,
    realimages,
    markedImages,
    readOnly = false
  } = props;
  const [data, setData] = useState([]);
  const [adicional, setAdicional] = useState(false);

  useEffect(() => {
    loadImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (realimages) {
      Object.keys(realimages).forEach(function test(key) {
        if (realimages[key].paso_nro === card.key) {
          setImagenReal(realimages[key].base64);
        }
      });
    }
  }, [card.key, realimages]);

  useEffect(() => {
    if (markedImages) {
      Object.keys(markedImages).forEach(function test(key) {
        if (markedImages[key].paso_nro === card.key) {
          setImagenMarcada(markedImages[key].base64);
        }
      });
    }
  }, [card.key, markedImages]);

  const texto = (
    <List size="small" dataSource={data} renderItem={(item) => <p>{item}</p>} />
  );

  const loadImage = () => {
    if (props.adicional) {
      setAdicional(true);
    }
    setLoading(true);
    if (imagenes) {
      Object.keys(imagenes).forEach(function test(key) {
        setParte(card.parte);
        if (imagenes[key].paso_nro === card.key) {
          setImagen(imagenes[key].base64);
          setFileName(imagenes[key].descripcion);
          setComentario(imagenes[key].comentario);
          try {
            if (imagenes[key].comentario.length > 0) {
              const comentarios = imagenes[key].comentario;
              const newData = [];
              comentarios.forEach((element) => {
                newData.push(`${element.pieza} ${element.danho}`);
              });
              setData(newData);
              setComentarioTooltip(true);
            }
          } catch (error) {
            // error
          }
        }
      });
      if (realimages) {
        Object.keys(realimages).forEach(function test(key) {
          if (realimages[key].paso_nro === card.key) {
            setImagenReal(realimages[key].base64);
          }
        });
      }
      if (markedImages) {
        Object.keys(markedImages).forEach(function test(key) {
          if (markedImages[key].paso_nro === card.key) {
            setImagenMarcada(markedImages[key].base64);
          }
        });
      }
    }

    setLoading(false);
  };

  const openEditor = () => {
    if (props.user) {
      message.info('El Admin de la Aseguradora solo tiene permisos de vista');
    } else if (inspeccion.estado === 'FINALIZADA') {
      message.info('La Inspección está Finalizada.');
    } else if (inspeccion.resultado !== 'VERIFICACION') {
      if (inspeccion.estado === 'FOTOS_SUBIDAS') {
        setModal(true);
        loadImage();
      } else if (inspeccion.estado === 'FINALIZADA') {
        message.info('La Inspección está Finalizada.');
      } else {
        message.info(
          'No puede realizar acciones el cliente tiene fotos pendientes.'
        );
      }
    } else {
      message.info(
        'No puede realizar acciones la Inspección está en estado de Verificación'
      );
    }
  };

  const showModal = (esComentario) => {
    if (props.user) {
      message.info('El Admin de la Aseguradora solo tiene permisos de vista');
    } else if (inspeccion.estado === 'FINALIZADA') {
      message.info('La Inspección está Finalizada.');
    } else if (inspeccion.resultado !== 'VERIFICACION') {
      if (inspeccion.estado === 'FOTOS_SUBIDAS') {
        if (esComentario) {
          setIsModalVisible(true);
        } else {
          setModal(true);
          loadImage();
        }
      } else if (inspeccion.estado === 'FINALIZADA') {
        message.info('La Inspección está Finalizada.');
      } else {
        message.info(
          'No puede realizar acciones el cliente tiene fotos pendientes.'
        );
      }
    } else {
      message.info(
        'No puede realizar acciones la Inspección está en estado de Verificación'
      );
    }
  };

  const handleOk = (comentarios) => {
    archivoAddComentario(
      inspeccion.id,
      card.key,
      comentarios,
      card.id_ampliacion
    );
    if (comentarios.length > 0) {
      setIsModalVisible(false);
      props.recibeComentarios(comentarios, card.parte);
      const newData = [];
      comentarios.forEach((element) => {
        newData.push(`${element.pieza} ${element.danho}`);
      });
      setData(newData);
      setComentarioTooltip(true);
    } else {
      message.info('No tiene comentarios nuevos que guardar.');
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleSaveName = (editval) => {
    archivoAddParte(inspeccion.id, card.key, editval);
    setParte(editval);
  };

  const reload = () => {
    loadImage();
  };

  return (
    <>
      <Col key={card.parte} xs={24} sm={12} md={8} lg={6}>
        <Card
          size="small"
          style={{ marginTop: 16 }}
          bodyStyle={{ paddingTop: 8, paddingBottom: 0 }}
          cover={
            <Spin spinning={loading}>
              <Image360
                style={{
                  textAlign: 'center',
                  height: 240,
                  padding: 1,
                  objectFit: 'contain'
                }}
                src={
                  imagenEditada ||
                  imagenMarcada ||
                  imagenReal ||
                  imagen ||
                  card.image
                }
                // imagenview={card.image}
                previewStyle={{ wrapperStyle: { with: '100%' } }}
                onClick={() => {
                  reload();
                }}
              />

              {/* <Image360
                style={{
                  textAlign: 'center',
                  height: 240,
                  padding: 1,
                  objectFit: 'contain'
                }}
                src={imagenReal}
                imagenview={imagen || card.image}
                // previewStyle={{ wrapperStyle: { with: '100%' } }}
                onClick={() => {
                  reload();
                }}
              /> */}
            </Spin>
          }
          actions={[
            <>
              {!readOnly && (
                <>
                  {comentarioTooltip ? (
                    <Popover content={texto} title="Comentarios">
                      <MessageOutlined
                        key="message"
                        style={{
                          width: 'initial',
                          color: CONFIG.COLOR_PRIMARY
                        }}
                        onClick={() => showModal(true)}
                      />
                    </Popover>
                  ) : (
                    <Tooltip title="Sin comentarios">
                      <MessageOutlined
                        key="message"
                        onClick={() => showModal(true)}
                      />
                    </Tooltip>
                  )}
                </>
              )}
            </>,

            <>
              {!readOnly && (
                <EditOutlined
                  key="edit"
                  style={{ width: 'auto' }}
                  onClick={() => openEditor(card, imagen)}
                />
              )}
            </>
          ]}
        >
          <Meta
            title={
              <Paragraph
                style={{ marginBottom: 0 }}
                ellipsis={{ tooltip: card.parte }}
                editable={
                  adicional &&
                  inspeccion.estado !== 'FINALIZADA' && {
                    onChange: handleSaveName
                  }
                }
              >
                {parte}
              </Paragraph>
            }
            description={
              <Paragraph ellipsis={{ tooltip: card.parteDescripcion }}>
                {card.parteDescripcion || <br />}
              </Paragraph>
            }
            style={{
              margin: 'auto',
              textAlign: 'center'
            }}
          />
        </Card>
      </Col>
      {modal && (
        <InspeccionProvider>
          <Editor
            image={imagenEditada || imagenMarcada || imagenReal}
            title="imagen"
            onSave={(img) => {
              if (img) {
                setImagenEditada(img.img);
                uploadMarkedFile(
                  solicitud,
                  inspeccion.token,
                  img.blob,
                  card.item,
                  fileName
                );
                showModal(true);
              }

              setModal(false);
            }}
            onRestore={() => {
              setImagenEditada(imagenReal);
              uploadMarkedFile(
                solicitud,
                inspeccion.token,
                b64toBlob(imagenReal.split(',')[1], 'application/jpeg'),
                card.item,
                fileName
              );
              setModal(false);
              // uploadMarkedFile(
              //   solicitud,
              //   inspeccion.id,
              //   null,
              //   card.item,
              //   fileName
              // );
              // setComment(true);
              // showModal(true);
              // setModal(false);
            }}
          />
        </InspeccionProvider>
      )}
      <Comentarios
        card={card}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        comentarios={comentario}
      />
    </>
  );
}
